import { type ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import PackBrowserModal from "./PackBrowserModal.js";

interface Props {
  tableId: string;
  uid: string | undefined;
  guildId: string | undefined;
  installedScenePackIds: string[];
  onNext: () => void;
  onSkip: () => void;
}

export default function WizardScenePackStep(props: Props): ReactElement {
  const { t } = useTranslation();
  const [browserOpen, setBrowserOpen] = useState(false);

  return (
    <section className="space-y-3">
      <h3 className="text-base font-semibold">{t("wizard.scene.title")}</h3>
      <p className="text-sm text-muted-foreground">{t("wizard.scene.desc")}</p>

      <div className="rounded border p-3 text-sm">
        {props.installedScenePackIds.length === 0 ? (
          <div className="italic text-muted-foreground">{t("wizard.scene.none")}</div>
        ) : (
          <ul className="space-y-1">
            {props.installedScenePackIds.map((id) => (
              <li key={id}>{id}</li>
            ))}
          </ul>
        )}
      </div>

      <div className="flex gap-2">
        <button
          type="button"
          className="rounded border px-3 py-1 text-sm"
          onClick={() => setBrowserOpen(true)}
        >
          {t("wizard.scene.browse")}
        </button>
        <button type="button" className="rounded border px-3 py-1 text-sm" onClick={props.onSkip}>
          {t("wizard.scene.skip")}
        </button>
        <button
          type="button"
          className="rounded bg-emerald-600 px-3 py-1 text-sm text-white"
          onClick={props.onNext}
        >
          {t("wizard.next")}
        </button>
      </div>

      <PackBrowserModal
        open={browserOpen}
        tableId={props.tableId}
        packKind="scene"
        guildId={props.guildId}
        uid={props.uid}
        installedIds={new Set(props.installedScenePackIds)}
        onClose={() => setBrowserOpen(false)}
      />
    </section>
  );
}
